(function() {
  var pages = {
    '/products/deutsch-hdp26-24-29se-hdp29-f': true,
    '/products/deutsch-hd34-24-29pe-hd30-29-pin-male-connector': true
  };
  var desired = [
    {
      handle: 'deutsch-hdp20-series-lock-washer-size-24-usa',
      title: 'Deutsch 2414-001-2486 HDP20 Lock Washer (Size 24)',
      role: 'Size 24 HDP20 lock washer',
      sku: 'TEC-2414-001-2486',
      price: '$2.99',
      stock: 'Available',
      variantId: '34418448891949',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-2414-001-2486_01_03797be9-138a-44a0-b6fe-3a767d47717b_360x360.jpg?v=1589892708'
    },
    {
      handle: 'deutsch-112264-zz-hd30-series-lock-washer-size-24',
      title: 'Deutsch 112264-ZZ HD30 Series Lock Washer (Size 24)',
      role: 'Size 24 HD30 lock washer',
      sku: 'TEC-112264-ZZ',
      price: '$1.79',
      stock: 'Available',
      variantId: '48036319789333',
      image: '//mypartsuniverse.com/cdn/shop/files/112264-ZZ_01_360x360.jpg?v=1709324768'
    },
    {
      handle: 'deutsch-114017-14-16awg-seal-plug',
      title: 'DEUTSCH 114017 12-16AWG Sealing Plug',
      role: 'Seal plug for unused size 12/16 cavities',
      sku: 'TEC-114017',
      price: '$0.49',
      stock: 'Available',
      variantId: '34418293604397',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-114017_01_360x360.jpg?v=1589891074'
    },
    {
      handle: 'deutsch-0413-204-2005-20awg-seal-plug',
      title: 'DEUTSCH 0413-204-2005 20AWG Seal Plug',
      role: 'Seal plug for unused size 20 cavities',
      sku: 'TEC-0413-204-2005',
      price: '$0.59',
      stock: 'Available',
      variantId: '34418290229293',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-0413-204-2005_01_360x360.jpg?v=1589891006'
    },
    {
      handle: 'deutsch-hd30-24bt-90-bk-black-90-deg-boot-size-24',
      title: 'DEUTSCH HD30-24BT-90-BK 90 degree Black Boot For HDP20 HD30 Connector (Size 24)',
      role: 'Size 24 90 degree boot',
      sku: 'TEC-HD30-24BT-90-BK',
      price: '$6.49',
      stock: 'Available',
      variantId: '34418322735149',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-HD30-24BT-90-BK_01_360x360.jpg?v=1589891358'
    },
    {
      handle: 'deutsch-whds-24-2-hd30-90-deg-strain-relief',
      title: 'DEUTSCH WHDS-24-2 90 degree Strain Relief For HD30 Connectors',
      role: 'Size 24 90 degree strain relief',
      sku: 'TEC-WHDS-24-2',
      price: '$21.99',
      stock: 'Available',
      variantId: '34418325880877',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-WHDS-24-2_01_360x360.jpg?v=1589891421'
    }
  ];

  function updateCard(card, item) {
    var href = '/products/' + item.handle;
    var media = card.querySelector('.pu-related-card__media');
    var image = card.querySelector('.pu-related-card__media img');
    var role = card.querySelector('.pu-related-card__role');
    var title = card.querySelector('.pu-related-card__title');
    var sku = card.querySelector('.pu-related-card__sku');
    var price = card.querySelector('.pu-related-card__price');
    var stock = card.querySelector('.pu-related-card__stock');
    var variant = card.querySelector('form.pu-related-card__cart input[name="id"]');
    var cta = card.querySelector('.pu-related-card__cta');

    if (media) {
      media.setAttribute('href', href);
      media.setAttribute('aria-label', item.title);
    }
    if (image) {
      image.setAttribute('src', item.image);
      image.setAttribute('alt', item.title);
    }
    if (role) role.textContent = item.role;
    if (title) {
      title.setAttribute('href', href);
      title.textContent = item.title;
    }
    if (sku) sku.textContent = 'SKU: ' + item.sku;
    if (price) price.textContent = item.price;
    if (stock) stock.textContent = item.stock;
    if (variant) variant.value = item.variantId;
    if (cta) cta.setAttribute('href', href);
    card.setAttribute('data-pu-hd-accessory-fallback', item.sku);
  }

  function makeCard(item) {
    var article = document.createElement('article');
    article.className = 'pu-related-card';
    article.setAttribute('data-pu-hd-accessory-fallback', item.sku);
    article.innerHTML = [
      '<a class="pu-related-card__media" href="/products/' + item.handle + '" aria-label="' + item.title + '">',
      '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">',
      '</a>',
      '<div class="pu-related-card__body">',
      '<span class="pu-related-card__role">' + item.role + '</span>',
      '<a class="pu-related-card__title" href="/products/' + item.handle + '">' + item.title + '</a>',
      '<span class="pu-related-card__sku">SKU: ' + item.sku + '</span>',
      '<div class="pu-related-card__meta"><span class="pu-related-card__price">' + item.price + '</span><span class="pu-related-card__stock">' + item.stock + '</span></div>',
      '<form class="pu-related-card__cart" method="post" action="/cart/add"><input type="hidden" name="id" value="' + item.variantId + '"><input type="hidden" name="quantity" value="1"><button class="pu-related-card__add" type="submit">Add to cart</button></form>',
      '<a class="pu-related-card__cta" href="/products/' + item.handle + '">View item</a>',
      '</div>'
    ].join('');
    return article;
  }

  function apply() {
    if (!pages[window.location.pathname]) return;
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var grid = groups[i].querySelector('.pu-related-card-grid');
      if (!grid) return;
      var currentText = groups[i].textContent;
      var cards = groups[i].querySelectorAll('.pu-related-card');
      for (var itemIndex = 0; itemIndex < desired.length; itemIndex += 1) {
        var item = desired[itemIndex];
        if (currentText.indexOf(item.sku.replace('TEC-', '')) !== -1 || currentText.indexOf(item.sku) !== -1) continue;
        var replaced = false;
        if (item.sku === 'TEC-HD30-24BT-90-BK') {
          for (var j = 0; j < cards.length; j += 1) {
            if (cards[j].textContent.indexOf('HDC26-24') !== -1) {
              updateCard(cards[j], item);
              replaced = true;
              break;
            }
          }
        }
        if (!replaced) grid.appendChild(makeCard(item));
        currentText += ' ' + item.sku + ' ' + item.title;
      }
    }
    dedupeHardwareProtectionCards();
  }

  function dedupeHardwareProtectionCards() {
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var seen = {};
      var cards = groups[i].querySelectorAll('.pu-related-card');
      for (var j = 0; j < cards.length; j += 1) {
        var skuText = cards[j].querySelector('.pu-related-card__sku');
        var sku = skuText ? skuText.textContent.replace(/^SKU:\s*/i, '').trim() : '';
        if (!sku) continue;
        if (seen[sku]) {
          cards[j].remove();
        } else {
          seen[sku] = true;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.setTimeout(apply, 1000);
  window.setTimeout(apply, 2500);
  window.setTimeout(dedupeHardwareProtectionCards, 3500);
})();
